module.exports = __webpack_public_path__ + "img/location_pin_finish.ec96b01c.svg";